import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'

export interface DictionaryConfigTable {
  id: string
  name: string
  code: string
  note: string
  sort: number
  enabled: boolean | string
  edit?: boolean
  _editSnapshot?: DictionaryConfigTable
}

export const useDictionary = defineStore('dictionary', {
  state: () => ({}),
  actions: {
    // 字典列表
    async dictList(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/dataDict/page',
          method: 'get',
          params
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 字典详情
    async getDictInfo(pid: string) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/dataDict/getDictInfo',
          method: 'get',
          params: { pid }
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 新增字典
    async addDict(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/dataDict/addDict',
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 更新字典
    async updateDict(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/dataDict/updateDict',
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 编辑字典
    async editDict(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/dataDict/editDict',
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 根据字典编码查询字典子项列表
    async getDict(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/dataDict/dict',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 区域树
    async getAreaTree() {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/dict/areaTree',
          method: 'get'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 删除字典
    async deleteDict(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/dataDict/delDict`,
          method: 'post',
          data
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
